import { useCalculator } from '../state/CalculatorProvider';
import { renderStepItem } from '../fields/renderItem';
import { StepNav } from './StepNav';
import { StepProgress } from './StepProgress';

export function StepPanel() {
  const { derived, state, setValue } = useCalculator();
  const step = derived.currentStep;
  if (!step) return null;

  const heading = typeof step.heading === 'function' ? step.heading(state.values) : step.heading;
  const intro = typeof step.intro === 'function' ? step.intro(state.values) : step.intro;

  if (step.layout) {
    const Layout = step.layout;
    return (
      <div className="hsab-calc__step-panel">
        <StepProgress />
        <Layout values={state.values} setValue={setValue} errors={derived.stepErrors} />
        <StepNav />
      </div>
    );
  }

  return (
    <div className="hsab-calc__step-panel">
      <StepProgress />
      {heading && <h2 className="hsab-calc__step-heading-main">{heading}</h2>}
      {intro && <div className="hsab-calc__step-intro">{intro}</div>}
      {step.items.map((item, i) => renderStepItem(item, i, state.values, setValue))}
      <StepNav />
    </div>
  );
}
